import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const folderGeneralInfoReducer = (state = initialState.currentFolder.generalInfo, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FOLDER_GENERAL_INFO_STARTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case actionTypes.LOAD_FOLDER_GENERAL_INFO_SUCCESS: {
      return {
        ...state,
        ...action.payload.generalInfo,
        loading: false,
        loaded: true
      };
    }
    default:
      return state;
  }
};
export default folderGeneralInfoReducer;
